import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';

import { type Observable as ObservableType, Observable } from 'rxjs/Observable';
import { log } from '@atlassian/jira-common-util-logging';
import { mentionsService } from '@atlassian/jira-mentions-indicator';
import {
	LOAD_CONFIG_DATA_MODEL_SUCCESS,
	LOAD_CONFIG_DATA_SUCCESS,
	SET_APP_DATA,
} from '../../state/actions/app';
import { mentionsLoadSuccess } from '../../state/actions/mentions';
import { getCardIds } from '../../state/selectors/cards';
import type { Action, ActionsObservable, MiddlewareAPI } from '../../state/types';

export function loadMentionsEpic(
	action$: ActionsObservable,
	store: MiddlewareAPI,
): ObservableType<Action> {
	return action$
		.ofType(LOAD_CONFIG_DATA_SUCCESS, LOAD_CONFIG_DATA_MODEL_SUCCESS, SET_APP_DATA)
		.switchMap(() => {
			const state = store.getState();
			const issueIds = getCardIds(state);

			return mentionsService(issueIds)
				.mergeMap((result) => Observable.of(mentionsLoadSuccess(result)))
				.catch((error) => {
					log.safeErrorWithoutCustomerData(
						'backlog.load-mentions-epic.failure',
						'Failed to load mentions data from REST',
						error,
					);
					return Observable.empty();
				});
		});
}
